<script>
import { mapGetters } from 'vuex'
import {
  CONSTANT,
  AUTHENTICATION_REASONS,
  SCOF_FLOW_OPTIONS,
  AUTH_METHODS,
  SCOF_FLOW,
  AUTH_METHOD_TYPE
} from '../../utils/constant'
import requestBody from '../../orchestration/authSDK/request-parameter'
import sharedService from '../../utils/shared-service'
import traceService from '../shared/trace/trace-service'
import { BPopover } from 'bootstrap-vue'
import OtpInputAuthentication from '../otp-input-authentication/otp-input-authentication.vue'
import OtpChannelSelector from '../otp-channel-selector/otp-channel-selector.vue'
import { EventBus } from '../../event-bus'

export default {
  name: 'Authentication',
  components: {
    OtpInputAuthentication,
    OtpChannelSelector,
    BPopover
  },
  props: {
    enrollMaskCardData: '',
    isReturningUser: {
      type: Boolean
    }
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      error: '',
      authenticationMethods: [],
      scofFlowOptions: SCOF_FLOW_OPTIONS,
      authenticationReasons: AUTHENTICATION_REASONS,
      authenticationMethodIndex: '',
      authenticationReasonIndex: '',
      enableAuthContinueButton: true,
      enableContinueButton: true,
      selectedSCOFFlow: '',
      isSPKChanges: false,
      SCOF_FLOW: SCOF_FLOW,
      initiateAuthParams: {},
      isMDESAuthenticateSuccess: false,
      otpInputScreen: false,
      autheMethods: [],
      isIDVInfoVisible: true
    }
  },

  computed: {
    ...mapGetters([
      'enrollMaskCard',
      'srcNetwork',
      'checkoutProgress',
      'saveMaskCard',
      'scofExecutionFlow',
      'apiEndpoints',
      'consumerInfo',
      'mdesExecutionFlow',
      'isNTSFlowEnabled',
      'enableNativeIntegrationFlow',
      'enableB2bAuthLookupFIDO'
    ]),
    isThirdPartyFIDOEnabled: {
      get () {
        return this.$store.getters.thirdPartyFIDO
      },
      set (value) {
        this.$store.commit('setThirdPartyFIDO', value)
      }
    },
    b2bAuthLookupReason: {
      get () {
        return this.$store.state.configuration.auth.b2bAuthLookupReason
      }
    }
  },

  created () {
    let isSTFChanges = sharedService.checkFeatureFlag('START_STF_CHANGES')
    let isIAOChanges = sharedService.checkFeatureFlag('START_IAO_CHANGES')
    this.isSPKChanges = sharedService.checkFeatureFlag('START_SPK_CHANGES')
    if (this.isNTSFlowEnabled && this.enableNativeIntegrationFlow) {
      this.selectedSCOFFlow = 'MDES_IDV'
      this.$store.commit('setScofExecutionFlow', this.selectedSCOFFlow)
    }

    if (this.selectScofFlow === '') {
      this.enableAuthContinueButton = false
    }
    if (
      !isSTFChanges
    ) {
      this.scofFlowOptions = Object.fromEntries(
        Object.entries(this.scofFlowOptions).filter(
          ([key, value]) => key !== SCOF_FLOW.TAV && key !== SCOF_FLOW.TXAV
        )
      )
    }

    if (!isIAOChanges) {
      this.scofFlowOptions = Object.fromEntries(
        Object.entries(this.scofFlowOptions).filter(
          ([key, value]) => key !== SCOF_FLOW.MDES_IDV
        )
      )
    }

    this.authenticationMethods = this.getAuthMethods()
  },

  methods: {
    countinueWithAnotherWay () {
      this.authMethods = this.getAuthMethods()
      this.otpInputScreen = false
    },
    resendOTP (authenticateRequest, authenticateResponse) {
      this.otpInputScreen = true
      this.initiateAuthParams.request = authenticateRequest
      this.initiateAuthParams.response = authenticateResponse
    },
    getAuthMethods () {
      if (this.isNTSFlowEnabled) {
        return this.enrollMaskCardData.authenticationMethods.filter(
          (method) =>
            method.authenticationMethodType === 'SMS_OTP' ||
            method.authenticationMethodType === 'EMAIL_OTP'
        )
      } else {
        return this.isReturningUser
          ? this.enrollMaskCardData.maskedCard.digitalCardData.authenticationMethods.filter(
            (methods) =>
              methods.authenticationMethodType !== '3DS' &&
              methods.authenticationMethodType !== 'MANAGED_AUTHENTICATION'
          )
          : this.enrollMaskCardData.authenticationMethods
      }
    },

    async executeAuthFlow () {
      if (this.enableB2bAuthLookupFIDO) {
        const selectedb2bAuthLookupReasons = Object.keys(this.b2bAuthLookupReason)
          .filter((lookupReason) => {
            if (this.b2bAuthLookupReason[lookupReason]) {
              return lookupReason
            }
          })

        if (this.authenticationReasons[this.authenticationReasonIndex] === CONSTANT.CONFIG.B2B_LOOKUP_REASON.AUTHENTICATOR_REGISTRATION &&
          this.authenticationMethods[this.authenticationMethodIndex].authenticationMethodType === AUTH_METHOD_TYPE.ONBEHALF_ISSUER_IDV &&
          this.scofExecutionFlow === SCOF_FLOW['MDES_IDV'] &&
          selectedb2bAuthLookupReasons[0] === CONSTANT.CONFIG.B2B_LOOKUP_REASON.AUTHENTICATOR_REGISTRATION
        ) {
          this.$store.commit('setIsIABFlow', true)
        } else {
          this.$store.commit('setIsIABFlow', false)
        }
      } else {
        this.$store.commit('setIsIABFlow', false)
      }
      if (
        this.scofExecutionFlow === SCOF_FLOW['MDES_IDV'] &&
        this.mdesExecutionFlow === 'B2B_API_FLOW'
      ) {
        await this.initiateAuthenticate()
      } else {
        const authenticationMethod =
          this.authenticationMethods[this.authenticationMethodIndex]
        const authenticationReason =
          this.authenticationReasons[this.authenticationReasonIndex]
        this.$refs.iframe.addEventListener('load', () => {
          this.$store.commit('checkoutProgress', true)
          this.$refs.iframeContainer.classList.add('show')
        })
        window.authIframe = this.$refs.iframe.contentWindow
        this.$emit(
          'initiate',
          authenticationMethod,
          authenticationReason,
          this.isReturningUser,
          this.enrollMaskCardData
        )
      }
    },

    checkAuthContinueButton () {
      if (
        this.authenticationMethodIndex !== '' &&
        this.authenticationReasonIndex !== ''
      ) {
        this.enableAuthContinueButton = false
      }
    },

    selectScofFlow () {
      this.enableContinueButton = false
    },

    async initiateExecutionFlow () {
      this.authenticationMethodIndex = ''
      this.authenticationReasonIndex = ''
      this.enableAuthContinueButton = true
      if (
        this.selectedSCOFFlow === SCOF_FLOW.TAV ||
        this.selectedSCOFFlow === SCOF_FLOW.TXAV
      ) {
        await this.executeTavOrTxavFlow()
        this.$router.push('/tavreview').catch((err) => {
          console.error(err)
        })
      }
      this.$store.commit('setScofExecutionFlow', this.selectedSCOFFlow)
      this.$store.commit('loaderOn', false)
    },

    async executeTavOrTxavFlow () {
      let response = await this.getGenerateTavOrTxav()
      this.$store.commit('setTavInfo', response.tavResponse)
      return true
    },

    async initiateAuthenticate () {
      this.error = ''
      this.$store.commit('loaderOn', true)
      const network = 'mastercard'
      const authenticationMethod =
        this.authenticationMethods[this.authenticationMethodIndex]
      const authenticationReason =
        this.authenticationReasons[this.authenticationReasonIndex]
      const enrollData = !this.enrollMaskCardData.enrollCardResponse
        ? this.enrollMaskCardData
        : this.enrollMaskCard
      let srcDigitalCardId, serviceId, srcCorrelationId

      if (this.isReturningUser) {
        EventBus.$emit('enableSaveCardCheckbox', false)
        const {
          maskedCard: {
            srcDigitalCardId: maskedSrcDigitalCardId,
            serviceId: maskedServiceId
          },
          srcCorrelationId: maskedSrcCorrelationId
        } = enrollData
        srcDigitalCardId = maskedSrcDigitalCardId
        serviceId = maskedServiceId
        srcCorrelationId = maskedSrcCorrelationId
      } else {
        ({ srcDigitalCardId, serviceId, srcCorrelationId } = enrollData)
      }

      let reqParams = requestBody[AUTH_METHODS.B2B_INITIATE_AUTHENTICATE](
        authenticationMethod,
        authenticationReason,
        srcCorrelationId,
        srcDigitalCardId,
        serviceId
      )
      try {
        let response = await sharedService.getB2BAuthenticateApiResponse(
          reqParams
        )
        this.$store.commit('loaderOn', false)
        traceService.updateCallTraces(network, response.callTraces, true)
        this.initiateAuthParams.request = reqParams
        this.initiateAuthParams.response = response
        this.isMDESAuthenticateSuccess = true
        this.otpInputScreen = true
        this.isIDVInfoVisible = false
        return response
      } catch (err) {
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        this.$store.commit('loaderOn', false)
        this.error = err.response.data.message
        return errorLog
      }
    },

    async getGenerateTavOrTxav () {
      this.$store.commit('loaderOn', true)
      const network = 'mastercard'
      const cardDetails = this.enrollMaskCardData.cardDetails
      if (cardDetails.encryptedCard) {
        delete cardDetails.encryptedCard
      }
      let srcNetwork = network.toUpperCase()
      let srcNetworkKeys = JSON.parse(
        this.apiEndpoints[srcNetwork].START_PUBLIC_KEY
      )
      try {
        let encryptedCardForTav = await sharedService.encryptCard(
          cardDetails,
          srcNetworkKeys['kid'],
          [srcNetworkKeys],
          true
        )
        let reqParams = requestBody[AUTH_METHODS.TAVGENERATE](
          encryptedCardForTav,
          this.enrollMaskCardData.enrollCardResponse.srcCorrelationId,
          this.selectedSCOFFlow
        )
        let response = await sharedService.getTAVGenerateApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        this.$store.commit('loaderOn', false)
        return response
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
      }
    },

    goBackToSelectionScreen () {
      this.$store.commit('setScofExecutionFlow', '')
      this.error = ''
    }
  }
}
</script>
<style scoped>
.highlight-bold {
  font-family: "Mpass-Bold";
  font-weight: 700;
}
</style>
<template>
  <div class="card-input-wrapper">
    <div
      v-if="!isNTSFlowEnabled && scofExecutionFlow !== '' && isIDVInfoVisible && !isReturningUser"
      class="alert alert-info mt-3"
      role="alert">
      <div class="d-flex align-items-center gap-2">
        <div>
          <i
            class="fa fa-info-circle fa-2x"
            aria-hidden="true" />
        </div>
        <div class="ml-2">
          <p class="mb-0">
            <span>{{ $t("label.IDV_INFO_1") }}
              <b class="highlight-bold">{{
                scofFlowOptions[selectedSCOFFlow]
              }}</b>
              {{ $t("label.IDV_INFO_2")
              }}<a
                class="text-primary cursor-pointer alert-link highlight-bold"
                @click="goBackToSelectionScreen()">{{
              $t("label.IDV_INFO_3") }}</a>.</span>
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      {{ error }}
    </div>
    <div
      id="iframeContainer"
      ref="iframeContainer"
      :class="[checkoutProgress ? 'show' : '']"
      class="iframe-container slide-in">
      <div class="iframe-foreground">
        <iframe
          id="checkoutIframe"
          ref="iframe"
          class="iframe-checkout"
          name="checkout-iframe" />
      </div>
      <div
        id="iframeBackgroundFIDO"
        ref="iframeBackground"
        class="iframe-background" />
    </div>
    <div v-if="!isMDESAuthenticateSuccess">
      <div
        v-if="scofExecutionFlow === ''"
        id="scof-flow-options"
        class="form-group"
        data-test="scof-flow-container">
        <label>{{ $t("label.scofFlowOptions") }}</label>
        <select
          id="scof-flow-options-ID"
          v-model="selectedSCOFFlow"
          class="option-dpa form-control"
          data-test="select-idv-method"
          @change="selectScofFlow()">
          <option
            value=""
            disabled
            selected>
            {{ $t("label.scofFlowOptions") }}
          </option>
          <option
            v-for="(key, value) in scofFlowOptions"
            :key="key"
            :value="value">
            {{ key }}
          </option>
        </select>
        <div
          v-if="isSPKChanges"
          id="authPreferenceId"
          class="mt-3">
          <div
            id="auth-preference-id"
            class="ml-2">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.THIRDPARTY_FIDO"
              :key="value"
              class="form-check form-check-inline">
              <input
                :id="'inlineRadio' + key"
                v-model="isThirdPartyFIDOEnabled"
                :data-test="'radio-' + key"
                :value="key"
                name="authPreference"
                class="form-check-input"
                type="radio" >
              <label
                :for="'inlineRadio' + key"
                class="form-check-label">
                {{ value }}
              </label>
            </div>
          </div>
        </div>
        <button
          id="continue-button"
          :disabled="enableContinueButton"
          class="btn btn-primary btn-lg mt-3 px-4"
          data-test="btn-continue"
          type="submit"
          @click="initiateExecutionFlow()">
          {{ $t("label.continueLabel") }}
        </button>
      </div>

      <div v-if="scofExecutionFlow !== '' && scofExecutionFlow !== SCOF_FLOW.TAV">
        <div
          id="authentication-method"
          class="form-group"
          data-test="authentication-method-container">
          <label>{{ $t("label.authenticationMethod") }}</label>
          <select
            id="authentication-method-ID"
            v-model="authenticationMethodIndex"
            class="option-dpa form-control"
            data-test="select-authentication-method"
            @change="checkAuthContinueButton()">
            <option
              value=""
              disabled
              selected>
              {{ $t("label.authenticationMethod") }}
            </option>
            <option
              v-for="(authMethod, index) in authenticationMethods"
              :key="index"
              :value="index">
              {{ authMethod.authenticationMethodType }}
            </option>
          </select>
        </div>
        <div
          id="authentication-reason"
          class="form-group"
          data-test="authentication-reason-container">
          <label>{{ $t("label.authenticationReason") }}</label>
          <select
            id="authentication-reason-ID"
            v-model="authenticationReasonIndex"
            class="option-dpa form-control"
            data-test="select-authentication-reason"
            @change="checkAuthContinueButton()">
            <option
              value=""
              disabled
              selected>
              {{ $t("label.authenticationReason") }}
            </option>
            <option
              v-for="(authReason, index) in authenticationReasons"
              :key="authReason"
              :value="index">
              {{ authReason }}
            </option>
          </select>
        </div>
      </div>
      <button
        v-if="scofExecutionFlow !== '' && scofExecutionFlow !== SCOF_FLOW.TAV"
        id="continue-button"
        :disabled="enableAuthContinueButton"
        class="btn btn-primary btn-lg mt-3 px-4"
        data-test="btn-continue"
        type="submit"
        @click="executeAuthFlow()">
        {{ $t("label.continueLabel") }}
      </button>
    </div>
    <div v-if="isMDESAuthenticateSuccess">
      <div v-if="otpInputScreen">
        <otp-input-authentication
          :initiate-auth-params="initiateAuthParams"
          @countinueWithAnotherWay="countinueWithAnotherWay" />
      </div>
      <div v-if="!otpInputScreen">
        <otp-channel-selector
          :authentication-methods="authMethods"
          :initiate-auth-params="initiateAuthParams"
          @resendOTP="resendOTP" />
      </div>
    </div>
  </div>
</template>
